import { motion } from 'framer-motion'
import { useEffect, useState, ElementType } from 'react'

const phrases = [
 {
  id: 'frase_1',
  parts: ['IN_', 'QUI', '_E', 'TA'],
  animations: ['x', 'y', 'y', 'x'],
  directions: [-100, -100, 100, 100],
  tag: 'h1'
 },
 {
  id: 'frase_2',
  parts: ['A_', '_GRE', 'GA_', 'DORA'],
  animations: ['x', 'y', 'y', 'x'],
  directions: [-100, -100, 100, 100],
  tag: 'h2'
 },
 {
  id: 'frase_3',
  parts: ['HU_', '_MA', 'NA'],
  animations: ['x', 'y', 'y'],
  directions: [-100, -100, 100],
  tag: 'h3'
 }
] as const

export function AnimatedPhrases() {
 const [index, setIndex] = useState(0)
 const [hasJS, setHasJS] = useState(false)

 useEffect(() => {
  setHasJS(true)
  const interval = setInterval(() => {
   setIndex(prev => (prev + 1) % phrases.length)
  }, 4000)
  return () => clearInterval(interval)
 }, [])

 return (
  <div className="relative w-1/2 h-[600px] max-[991px]:mt-[70px] max-[991px]:w-full max-[767px]:h-[380px] z-10">
   {/* STATIC HEADINGS for SEO + no-JS fallback */}

   {!hasJS && (
    <div className="sr-only">
     {phrases.map(phrase => {
      const Tag = phrase.tag as ElementType
      return <Tag key={phrase.id}>{phrase.parts.join('')}</Tag>
     })}
    </div>
   )}

   {/* JS-ENABLED ANIMATIONS */}

   {hasJS &&
    phrases.map((phrase, phraseIndex) => {
     const Tag = phrase.tag as ElementType
     const MotionHeading = motion.create(Tag)

     return index === phraseIndex ? (
      <MotionHeading
       key={phrase.id}
       className={`text-[var(--text-main)] font-bold text-[100px] min-[1700px]:text-[140px] max-[360px]:text-[55px] max-[767px]:text-[82px] leading-[120px] tracking-[13px] font-['rns-milesblack'] frase_${
        phraseIndex + 1
       }`}
       initial={{ opacity: 0 }}
       animate={{
        opacity: hasJS && index === phraseIndex ? 1 : 0,
        transition: { duration: 0.5 }
       }}
       aria-hidden={false}
       exit={{ opacity: 0 }}
      >
       {phrase.parts.map((part, i) => (
        <motion.span
         key={i}
         className={`absolute s${i + 1}`}
         initial={{ opacity: 0, [phrase.animations[i]]: phrase.directions[i] }}
         animate={{ opacity: 1, [phrase.animations[i]]: 0 }}
         transition={{ delay: i * 0.25 + 0.2, duration: 0.6, ease: 'easeOut' }}
        >
         {part}
        </motion.span>
       ))}
      </MotionHeading>
     ) : null
    })}
  </div>
 )
}
